import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FORM } from '../../../constants/props';
import { loginSchema } from '../../../constants/schemas';
import Input from '../../common/input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';

const useStyles = makeStyles({
  title: {
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
    marginBottom: '1.75rem',
  },
  formComponent: {
    marginBottom: '.625rem',
  },
  gLogin: {
    marginLeft: '.625rem',
  },
});

const LoginForm = ({ disabled, onSubmit, loginGoogle }) => {
  const classes = useStyles();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(loginSchema),
  });

  return (
    <form>
      <Grid container>
        <Typography className={classes.title} component="h1">
          Login
        </Typography>
        <Grid container className={classes.formComponent}>
          <Controller
            control={control}
            name="email"
            defaultValue=""
            render={({ onChange, value }) => (
              <Input
                type="email"
                value={value}
                placeholder="email"
                invalid={errors && errors.email}
                message={errors && errors.email && errors.email.message}
                onChange={onChange}
              />
            )}
          />
        </Grid>
        <Grid container className={classes.formComponent}>
          <Controller
            control={control}
            name="password"
            defaultValue=""
            render={({ onChange, value }) => (
              <Input
                type="password"
                value={value}
                placeholder="password"
                invalid={errors && errors.password}
                message={errors && errors.password && errors.password.message}
                onChange={onChange}
              />
            )}
          />
        </Grid>
        <Button
          disabled={disabled}
          variant="contained"
          color="primary"
          onClick={handleSubmit(onSubmit)}
        >
          Login
        </Button>
        <Button
          disabled={disabled}
          variant="outlined"
          color="primary"
          onClick={loginGoogle}
          className={classes.gLogin}
          startIcon={<FontAwesomeIcon icon={faGoogle} />}
        >
          - Login
        </Button>
      </Grid>
    </form>
  );
};

LoginForm.defaultValue = {
  disabled: false,
};

LoginForm.propTypes = {
  FORM,
};

export default LoginForm;
